import { deepmerge } from "@mui/utils";

type ScrollbarMode = "light" | "dark";

export const scrollbarStyleThemeOverrides = {
	"&::-webkit-scrollbar-track": {
		background: "transparent",
		boxShadow: "none",
	},
	"&::-webkit-scrollbar-thumb": {
		background: "var(--scrollbar-background)",
		outline: "none",
	},
	"&::-webkit-scrollbar-thumb:hover": {
		background: "var(--scrollbar-background-hover)",
	},
	"&::-webkit-scrollbar-thumb:active": {
		background: "var(--scrollbar-background-active)",
	},
	"&::webkit-scrollbar-track-piece:start": {
		background: "transparent",
	},
	"&::webkit-scrollbar-track-piece:end": {
		background: "transparent",
	},
};

export function getScrollbarColourThemeOverrides(mode: ScrollbarMode = "light") {
	return {
		"--scrollbar-background": mode === "light" ? "#E8E8E8" : "#8C8C8C",
		"--scrollbar-background-hover": mode === "light" ? "#BABABA" : "#808080",
		"--scrollbar-background-active": mode === "light" ? "#7C7C7C" : "#696969",
	};
}

export function getScrollbarThicknessThemeOverrides(thickness: string | number = 10) {
	return {
		"&::-webkit-scrollbar": {
			width: thickness,
			height: thickness,
		},
		"&::-webkit-scrollbar-thumb": {
			borderRadius: thickness,
		},
	};
}

export function getCombinedScrollbarThemeOverrides({
	thickness,
	mode,
}: {
	thickness?: string | number;
	mode?: ScrollbarMode;
} = {}) {
	return deepmerge(
		deepmerge(scrollbarStyleThemeOverrides, getScrollbarColourThemeOverrides(mode)),
		getScrollbarThicknessThemeOverrides(thickness),
	);
}

export const scrollbarThemeOverrides = getCombinedScrollbarThemeOverrides();
export default scrollbarThemeOverrides;
